import OfficeOverheadItem from "./OfficeOverheadItem";

class OfficeOverheadQuarterItem 
{
	constructor(item) 
	{
		if (item === undefined) 
		{
			this.Quarter = "";
			this.OfficeOverheadList = [];
		}
		else 
		{
			this.Quarter = item.quarter;
			this.OfficeOverheadList = OfficeOverheadQuarterItem.ConvertAvailableQuarterList(item.officeOverheadList)
		}
	}

	static CreateEditedOfficeOverheadItemObject(items) 
	{
		const officeOverheadList = [];
    items.OfficeOverheadList.forEach((item) => {
      const officeOverheadItem = OfficeOverheadItem.ToString(item);
      officeOverheadList.push(officeOverheadItem);
    });

		const eeoJson = {
      Quarter: items.Quarter.toString(),
      OfficeOverheadList: officeOverheadList,
    };
		return JSON.stringify(eeoJson);
	}

	

	static ConvertAvailableQuarterList(items) 
	{
		const convertedItems = [];
		if (items !== null) {
			items.forEach((item) => {
				convertedItems.push(new OfficeOverheadItem(item));
			});
		}
		return convertedItems;
	}
}

export default OfficeOverheadQuarterItem;